import React, { useState } from 'react';
import {
    EditFilled
} from '@ant-design/icons';
import {
    Button,
    Form,
    Modal,
    Row,
    Col,
    InputNumber,
    message
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function EditFormModal({ data }) {
    const [messageApi, contextHolder] = message.useMessage();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const queryClient = useQueryClient();
    const { mutate, isLoading } = useMutation({
        mutationFn: ({ values, id }) => {
            axios
                .put(`/api/cartItem/${id}`, values)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration: 1,
                        onClose: () => setOpen(false)
                    });
                    queryClient.invalidateQueries(['/api/cartItem/getReceiveCartItems'])
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });


    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate({ values, id: data._id }))
    };

    const onCancelCreate = () => {
        setOpen(false);
    }
    // console.log(data);
    return (
        <div>
            {contextHolder}
            <Button
                type='text'
                icon={<EditFilled />}
                style={{ color: '#5f77fc' }}
                onClick={() => setOpen(true)} />
            <Modal
                open={open}
                title={`แก้ไขสินค้า ${data.product.name}`}
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        ยกเลิก
                    </Button>,
                    <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                        ตกลง
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name={`edit${data._id}`}
                    initialValues={data}
                >
                    <Row gutter={[8, 8]}>
                        <Col xs={12}>
                            <Form.Item
                                label="ราคาขายต่ำสุด"
                                name="quantity"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                        <Col xs={12}>
                            <Form.Item
                                label="ราคาปกติ"
                                name="price"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </div>

    )
}
